import React from 'react';
import { Link } from 'react-router-dom';
import { convertDateToStrDuration } from '../../../../libs/helper';
import Avatar from '../../../components/Avatar/Avatar';
import Badge from '../../UI/Badge/Badge';

const StoryViewerListItem = ({ viewer, createdAt, onClose = () => {} }) => {
    if (!viewer) return null;
    const username = viewer.username || '';
    const slug = viewer.slug || '';

    return (
        <li className="story-viewers-list-item">
            <Link
                to={`/profils/${slug}`}
                className="story-viewers-list-item-link"
                onClick={() => onClose()}
            >
                {/* <Avatar> gère le défaut par genre + le resize via l'image worker (cohérent avec
                    le reste du site). */}
                <Avatar
                    avatar={viewer.profile?.avatar}
                    gender={viewer.profile?.gender}
                    width={40}
                    height={40}
                    alt={username}
                />
                <div className="story-viewers-list-item-info">
                    <div className="story-viewers-list-item-username">
                        <span className="story-viewers-list-item-username-text">{username}</span>
                        <Badge user={viewer} />
                    </div>
                    <div className="story-viewers-list-item-time">{convertDateToStrDuration(createdAt)}</div>
                </div>
            </Link>
        </li>
    );
};

export default StoryViewerListItem;
